<template>
  <div class="site2026-auth">
    <aside class="site2026-auth-left">
      <a href="/" class="site2026-auth-brand">
        <span class="site2026-auth-brand-mark" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M17.5 19H9a7 7 0 1 1 1.3-13.9A6 6 0 1 1 17.5 19Z" /></svg>
        </span>
        <span>Bmob</span>
      </a>
      <div class="site2026-auth-lead">
        <h2>让开发<br>变得简单</h2>
        <p>Bmob 后端云为你提供完整的 Serverless 后端能力，5 分钟即可上线应用，专注产品创新。</p>
        <ul class="site2026-auth-points">
          <li>
            <span class="point-check" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
            </span>
            <span>免费开始，按用量付费</span>
          </li>
          <li>
            <span class="point-check" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
            </span>
            <span>云数据库 / 云函数 / 短信 / AI 大模型一体化</span>
          </li>
          <li>
            <span class="point-check" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
            </span>
            <span>50W+ 开发者的信赖之选</span>
          </li>
        </ul>
      </div>
      <div class="site2026-auth-foot">
        © 2012-{{ currentYear }} 元素（深圳）软件有限公司
      </div>
    </aside>
    <section class="site2026-auth-right">
      <router-view :key="$route.path" />
    </section>
  </div>
</template>

<script>
export default {
  name: 'Site2026AuthLayout',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  },
  mounted() {
    this.ensureInter()
  },
  methods: {
    ensureInter() {
      if (document.getElementById('site2026-inter-font')) return
      const link = document.createElement('link')
      link.id = 'site2026-inter-font'
      link.rel = 'stylesheet'
      link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap'
      document.head.appendChild(link)
    }
  }
}
</script>

<style lang="scss">
@import '~@/styles/site2026/tokens.scss';
@import '~@/styles/site2026/forms.scss';
</style>
